import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import SEOHead from './components/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedWork from './components/FeaturedWork';
import TeluguMoviesSection from './components/TeluguMoviesSection';
import OriginalsSection from './components/OriginalsSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import ServicesSection from './components/ServicesSection';
import PipelineSection from './components/PipelineSection';
import TeamSection from './components/TeamSection';
import SearchIntentDirectory from './components/SearchIntentDirectory';
import FAQSection from './components/FAQSection';
import FooterCTA from './components/FooterCTA';
import StadiumVfxCaseStudy from './pages/StadiumVfxCaseStudy';
import PillarLandingPage from './pages/PillarLandingPage';
import { SHOWREEL_URL } from './data/portfolioData';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <SEOHead />
      <Navigation />

      <main>
        <HeroSection videoSrc={SHOWREEL_URL} />
        <FeaturedWork initialCategory="brand_work" />
        <TeluguMoviesSection />
        <OriginalsSection />
        <BeforeAfterSection />
        <ServicesSection />
        <PipelineSection />
        <SearchIntentDirectory />
        <TeamSection />
        <FAQSection />
      </main>

      <FooterCTA />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/work" element={<PillarLandingPage pillarKey="work" />} />
        <Route path="/ai-vfx" element={<PillarLandingPage pillarKey="ai-vfx" />} />
        <Route path="/ai-ugc-agency" element={<PillarLandingPage pillarKey="ai-ugc-agency" />} />
        <Route path="/micro-drama-production" element={<PillarLandingPage pillarKey="micro-drama-production" />} />
        <Route
          path="/ai-commercials-ugc"
          element={<PillarLandingPage pillarKey="ai-commercials-ugc" />}
        />
        <Route
          path="/ai-filmmaking"
          element={<PillarLandingPage pillarKey="ai-filmmaking" />}
        />
        <Route path="/case-studies/stadium-vfx" element={<StadiumVfxCaseStudy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
